import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  text: string;
  clubCode?: string;
  startDate?: string;
  endDate?: string;
}

@Component({
  selector: 'app-open-dialog-in-construction',
  templateUrl: './open-dialog-in-construction.component.html',
  styleUrls: ['./open-dialog-in-construction.component.scss']
})

export class OpenDialogInConstructionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpenDialogInConstructionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,

  ) { }

  ngOnInit(): void {
  }

}
